// use this Api as a function to make api calls;
import axiosInstance from '../axios';
import { API_ROUTES } from '../../enums/API_ROUTES';
import { SortOptions, SortType } from '../../enums/SORT';

export const getSubGroupsByGroupId = async (groupId: string, sort: SortType, sortOption: SortOptions) => {
  let sortField = sortOption;
  if (sortOption === 'size') {
    sortField = SortOptions.NAME;
  }
  const res = await axiosInstance.get(`${API_ROUTES.SUBGROUPS}?groupId=${groupId}&sort=${sort}&sortField=${sortField}`);
  return res;
};

export const getSubGroupById = async (subGroupId: string) => {
  const res = await axiosInstance.get(`${API_ROUTES.SUBGROUPS}/{id}?id=${subGroupId}`);
  return res;
};

type TpostCreateNewSubGroup = {
  title: string;
  groupId: string;
  analysts: string[];
  viewers: string[];
};

export const postCreateNewSubGroup = async (data: TpostCreateNewSubGroup) => {
  const res = await axiosInstance.post(`${API_ROUTES.SUBGROUPS}`, data);
  return res;
};

export const deleteSubGroupById = async (id: string) => {
  const res = await axiosInstance.delete(`${API_ROUTES.SUBGROUPS}/${id}`);
  return res;
};

type TpatchSubGroupAnalysts = {
  title?: string;
  usersToAdd?: string[];
  usersToRemove?: string[];
  groupId: string;
  allow_download_own_composers?: boolean;
};

export const patchSubGroupAnalysts = async (subGroupId: string, data: TpatchSubGroupAnalysts) => {
  const res = await axiosInstance.patch(`${API_ROUTES.SUBGROUPS}/${subGroupId}`, data);
  return res;
};

type TpatchSubGroupViewers = {
  viewersToAdd?: string[];
  viewersToRemove: string[];
  groupId: string;
};

export const patchSubGroupViewers = async (subGroupId: string, data: TpatchSubGroupViewers) => {
  const res = await axiosInstance.patch(`${API_ROUTES.SUBGROUPS}/${subGroupId}`, data);
  return res;
};
